<div
    [id]="graphId"
    class="solidGaugeChart tw-flex tw-justify-center tw-w-full"
></div>
